export const CASUAL_PAGE_CONFIG = {
  "title": "Realtime Users",
  "titleCN": "实时用户",
  "subTitle": "Timezone (UTC{{timeZone}})",
  "subTitleCN": "时区 (UTC{{timeZone}})",
  "path": "/realtime/users",
  "defaultTab": "users",
  "tabList": [
    {
      "id": "users",
      "tabName": "Users",
      "tabNameCN": "用户",
      "isHaveNotification": true,
      "refresh": true,
      "notificationPath": "/realtime/users/users",
      "path": "/realtime/users",
      "tabIcon": "",
      "logConfig": {
        "pageId": "200501",
        "pageName": "realtimeRealtimeUsersUsers",
        "extInfo": "realtimeRealtimeUsersUsers",
        "pagePath": "/realtime/users"
      },
      "filters": [
        {
          "name": "realtimeUserFilter",
          "isOpenSticky": false,
          "isHaveFilterSave": true,
          "filterPath": "/realtime/users",
          "selectorApi": "/api/v1/dashboard/pc/realtime/ua/selector",
          "extraSelectorParams": {
            "data_source": "dashboard"
          },
          "componentList": [
            {
              "name": "MetricInfo",
              "children": [
                {
                  "name": "realtimeUserService",
                  "className": "",
                  "type": "view",
                  "style": {},
                  "props": {
                    "config": {
                      "api": "/api/v1/dashboard/realtime/usertag",
                      "dataKey": "usertag",
                      "refreshKey": "realtime_user_usertag",
                      "interval": 300000,
                      "extraParams": {
                        "metrics": ["active_users", "new_users"],
                      }
                    }
                  },
                  "children": [
                    {
                      "name": "realtimeUserService",
                      "className": "",
                      "type": "view",
                      "style": {},
                      "props": {
                        "config": {
                          "api": "/api/v1/dashboard/realtime/retention",
                          "dataKey": "retention",
                          "refreshKey": "realtime_user_retention",
                          "interval": 300000
                        }
                      },
                      "children": [
                        {
                          "name": "realtimeUserService",
                          "className": "",
                          "type": "view",
                          "style": {},
                          "props": {
                            "config": {
                              "api": "/api/v1/dashboard/event_analysis/realtime/date_event_list",
                              "dataKey": "date_event_list",
                              "refreshKey": "realtime_user_event",
                              "interval": 300000
                            }
                          },
                          "children": [
                            {
                              "name": "MetricsCardTitle",
                              "className": "",
                              "type": "view",
                              "style": {},
                              "props": {
                                "config": {
                                  "titleEn": "Realtime Key Metrics",
                                  "titleCn": "实时关键指标",
                                  "data": [
                                    {
                                      "metricsEn": "{{metricsInfo.realtime_new_users.en}}",
                                      "metricsCn": "{{metricsInfo.realtime_new_users.cn}}",
                                      "explainEn": "{{metricsInfo.realtime_new_users.explainEn}}",
                                      "explainCn": "{{metricsInfo.realtime_new_users.explainCn}}",
                                    },
                                    {
                                      "metricsEn": "{{metricsInfo.realtime_active_users.en}}",
                                      "metricsCn": "{{metricsInfo.realtime_active_users.cn}}",
                                      "explainEn": "{{metricsInfo.realtime_active_users.explainEn}}",
                                      "explainCn": "{{metricsInfo.realtime_active_users.explainCn}}",
                                    },
                                    {
                                      "metricsEn": "{{metricsInfo.realtime_d2t1.en}}",
                                      "metricsCn": "{{metricsInfo.realtime_d2t1.cn}}",
                                      "explainEn": "{{metricsInfo.realtime_d2t1.explainEn}}",
                                      "explainCn": "{{metricsInfo.realtime_d2t1.explainCn}}",
                                    },
                                    {
                                      "metricsEn": "{{metricsInfo.realtime_d3t2.en}}",
                                      "metricsCn": "{{metricsInfo.realtime_d3t2.cn}}",
                                      "explainEn": "{{metricsInfo.realtime_d3t2.explainEn}}",
                                      "explainCn": "{{metricsInfo.realtime_d3t2.explainCn}}",
                                    },
                                    {
                                      "metricsEn": "{{metricsInfo.realtime_d7t6.en}}",
                                      "metricsCn": "{{metricsInfo.realtime_d7t6.cn}}",
                                      "explainEn": "{{metricsInfo.realtime_d7t6.explainEn}}",
                                      "explainCn": "{{metricsInfo.realtime_d7t6.explainCn}}",
                                    },
                                    {
                                      "metricsEn": "{{metricsInfo.realtime_dod.en}}",
                                      "metricsCn": "{{metricsInfo.realtime_dod.cn}}",
                                      "explainEn": "{{metricsInfo.realtime_dod.explainEn}}",
                                      "explainCn": "{{metricsInfo.realtime_dod.explainCn}}",
                                    },
                                    {
                                      "metricsEn": "{{metricsInfo.realtime_sdlw.en}}",
                                      "metricsCn": "{{metricsInfo.realtime_sdlw.cn}}",
                                      "explainEn": "{{metricsInfo.realtime_sdlw.explainEn}}",
                                      "explainCn": "{{metricsInfo.realtime_sdlw.explainCn}}",
                                    }
                                  ],
                                }
                              }
                            },
                            {
                              "name": "MetricCardCo",
                              "className": "dbd-retention-card",
                              "type": "view",
                              "style": {},
                              "props": {
                                "config": {}
                              },
                              "children": [
                                {
                                  "name": "CommonRow",
                                  "className": "",
                                  "type": "layout",
                                  "style": {},
                                  "props": {},
                                  "children": [
                                    {
                                      "name": "CommonCol",
                                      "className": "",
                                      "type": "layout",
                                      "style": {
                                        "width": "20%"
                                      },
                                      "props": {},
                                      "children": [
                                        {
                                          "name": "MetricsCardContext",
                                          "className": "",
                                          "type": "view",
                                          "style": {},
                                          "props": {
                                            "config": {
                                              "apiDataKey": "usertag",
                                              "dataKey": [
                                                "new_users_card"
                                              ],
                                              "isRealTime": true
                                            }
                                          },
                                          "children": [
                                            {
                                              "name": "MetricComponent",
                                              "path": "realtime/users",
                                              "componentKey": "NewUsersMetricCard",
                                              "className": "dbd-realtime-casual-metric-card",
                                              "height": 164,
                                              "config": {
                                                "props": {
                                                  "isRealTime": true,
                                                  "isPlaceholderTime": true
                                                }
                                              }
                                            }
                                          ]
                                        }
                                      ]
                                    },
                                    {
                                      "name": "CommonCol",
                                      "className": "",
                                      "type": "layout",
                                      "style": {
                                        "width": "20%"
                                      },
                                      "props": {},
                                      "children": [
                                        {
                                          "name": "MetricsCardContext",
                                          "className": "",
                                          "type": "view",
                                          "style": {},
                                          "props": {
                                            "config": {
                                              "apiDataKey": "usertag",
                                              "dataKey": [
                                                "active_users_card"
                                              ],
                                              "isRealTime": true
                                            }
                                          },
                                          "children": [
                                            {
                                              "name": "MetricComponent",
                                              "path": "realtime/users",
                                              "componentKey": "ActiveUsersMetricCard",
                                              "className": "dbd-realtime-casual-metric-card",
                                              "height": 164,
                                              "config": {
                                                "props": {
                                                  "isRealTime": true,
                                                  "isPlaceholderTime": true
                                                }
                                              }
                                            }
                                          ]
                                        }
                                      ]
                                    },
                                    {
                                      "name": "CommonCol",
                                      "className": "",
                                      "type": "layout",
                                      "style": {
                                        "width": "20%"
                                      },
                                      "props": {},
                                      "children": [
                                        {
                                          "name": "MetricsCardContext",
                                          "className": "",
                                          "type": "view",
                                          "style": {},
                                          "props": {
                                            "config": {
                                              "apiDataKey": "retention",
                                              "dataKey": [
                                                "d2_card"
                                              ],
                                              "isRealTime": true
                                            }
                                          },
                                          "children": [
                                            {
                                              "name": "MetricComponent",
                                              "path": "realtime/users",
                                              "componentKey": "d2t1MetricCard",
                                              "className": "dbd-realtime-casual-metric-card",
                                              "height": 164,
                                              "config": {
                                                "props": {
                                                  "isRealTime": true,
                                                  "isPlaceholderTime": true
                                                }
                                              }
                                            }
                                          ]
                                        }
                                      ]
                                    },
                                    {
                                      "name": "CommonCol",
                                      "className": "",
                                      "type": "layout",
                                      "style": {
                                        "width": "20%"
                                      },
                                      "props": {},
                                      "children": [
                                        {
                                          "name": "MetricsCardContext",
                                          "className": "",
                                          "type": "view",
                                          "style": {},
                                          "props": {
                                            "config": {
                                              "apiDataKey": "retention",
                                              "dataKey": [
                                                "d3_card"
                                              ],
                                              "isRealTime": true
                                            }
                                          },
                                          "children": [
                                            {
                                              "name": "MetricComponent",
                                              "path": "realtime/users",
                                              "componentKey": "d3t2MetricCard",
                                              "className": "dbd-realtime-casual-metric-card",
                                              "height": 164,
                                              "config": {
                                                "props": {
                                                  "isRealTime": true,
                                                  "isPlaceholderTime": true
                                                }
                                              }
                                            }
                                          ]
                                        }
                                      ]
                                    },
                                    {
                                      "name": "CommonCol",
                                      "className": "",
                                      "type": "layout",
                                      "style": {
                                        "width": "20%"
                                      },
                                      "props": {},
                                      "children": [
                                        {
                                          "name": "MetricsCardContext",
                                          "className": "",
                                          "type": "view",
                                          "style": {},
                                          "props": {
                                            "config": {
                                              "apiDataKey": "retention",
                                              "dataKey": [
                                                "d7_card"
                                              ],
                                              "isRealTime": true
                                            }
                                          },
                                          "children": [
                                            {
                                              "name": "MetricComponent",
                                              "path": "realtime/users",
                                              "componentKey": "d7t6MetricCard",
                                              "className": "dbd-realtime-casual-metric-card",
                                              "height": 164,
                                              "config": {
                                                "props": {
                                                  "isRealTime": true,
                                                  "isPlaceholderTime": true
                                                }
                                              }
                                            }
                                          ]
                                        }
                                      ]
                                    }
                                  ]
                                }
                              ]
                            },
                            {
                              "name": "SegmentScrollCo",
                              "className": "margin-t-20",
                              "style": {},
                              "type": "view",
                              "props": {
                                "config": {
                                  "componentSegment": [
                                    {
                                      "value": "1",
                                      "enName": "{{metricsInfo.realtime_new.en}}",
                                      "cnName": "{{metricsInfo.realtime_new.cn}}",
                                    },
                                    {
                                      "value": "2",
                                      "enName": "{{metricsInfo.realtime_active.en}}",
                                      "cnName": "{{metricsInfo.realtime_active.cn}}",
                                    },
                                    {
                                      "value": "3",
                                      "enName": "{{metricsInfo.realtime_retention_d2.en}}",
                                      "cnName": "{{metricsInfo.realtime_retention_d2.cn}}",
                                    },
                                    {
                                      "value": "4",
                                      "enName": "{{metricsInfo.realtime_retention_d3.en}}",
                                      "cnName": "{{metricsInfo.realtime_retention_d3.cn}}",
                                    },
                                    {
                                      "value": "5",
                                      "enName": "{{metricsInfo.realtime_retention_d7.en}}",
                                      "cnName": "{{metricsInfo.realtime_retention_d7.cn}}",
                                    }
                                  ],
                                  "scrollMarginTop": "75px"
                                }
                              },
                              "children": [
                                {
                                  "name": "MetricComponent",
                                  "path": "realtime/users",
                                  "componentKey": "NewUsersRealtimeCard",
                                  "id": 1,
                                  "config": {}
                                },
                                {
                                  "name": "MetricComponent",
                                  "path": "realtime/users",
                                  "componentKey": "ActiveUsersRealtimeCard",
                                  "id": 2,
                                  "config": {}
                                },
                                {
                                  "name": "MetricComponent",
                                  "path": "realtime/users",
                                  "componentKey": "RetentionD2RealtimeCard",
                                  "id": 3,
                                },
                                {
                                  "name": "MetricComponent",
                                  "path": "realtime/users",
                                  "componentKey": "RetentionD3RealtimeCard",
                                  "id": 4,
                                  "config": {}
                                },
                                {
                                  "name": "MetricComponent",
                                  "path": "realtime/users",
                                  "componentKey": "RetentionD7RealtimeCard",
                                  "id": 5,
                                  "config": {}
                                },
                              ]
                            }
                          ]
                        }
                      ]
                    }
                  ]
                }
              ]
            }
          ]
        }
      ]
    },
    {
      "id": "byCountryRegionZone",
      "tabName": "By Platform/Region/Country",
      "tabNameCN": "分平台/区域/国家",
      "isHaveNotification": true,
      "refresh": true,
      "notificationPath": "/realtime/users/byCountryRegionZone",
      "path": "/realtime/users/byCountryRegionZone",
      "tabIcon": "",
      "logConfig": {
        "pageId": "200502",
        "pageName": "realtimeRealtimeUsersByCountryRegionZone",
        "extInfo": "realtimeRealtimeUsersByCountryRegionZone",
        "pagePath": "/realtime/users/byCountryRegionZone"
      },
      "filters": [
        {
          "name": "realtimeCountryFilter",
          "isOpenSticky": false,
          "isHaveFilterSave": true,
          "filterPath": "/realtime/users/byCountryRegionZone",
          "selectorApi": "/api/v1/dashboard/pc/realtime/ua/selector",
          "extraSelectorParams": {
            "data_source": "dashboard"
          },
          "componentList": [
            {
              "name": "MetricInfo",
              "children": [
                {
                  "name": "realtimeUserService",
                  "className": "dbd-daily-card",
                  "type": "view",
                  "style": {},
                  "props": {
                    "config": {
                      "api": "/api/v1/dashboard/realtime/new_active_online",
                      "dataKey": "country_new_active_online",
                      "refreshKey": "realtime_country_new_active_online",
                      "interval": 300000,
                      "extraParams": {
                        "metrics": ["active_users", "new_users"],
                      }
                    }
                  },
                  "data": {
                    "dataBy": "system"
                  },
                  "children": [
                    {
                      "name": "realtimeUserService",
                      "className": "dbd-daily-card",
                      "type": "view",
                      "style": {},
                      "props": {
                        "config": {
                          "api": "/api/v1/dashboard/realtime/retention_d237",
                          "dataKey": "country_d237",
                          "refreshKey": "realtime_country_d237",
                          "interval": 300000
                        }
                      },
                      "children": [
                        {
                          "name": "ScrollBodyCo",
                          "className": "margin-t-20",
                          "style": {},
                          "type": "view",
                          "props": {
                            "config": {
                              "dataKey": "dataBy",
                              "componentSegment": [
                                {
                                  "value": "1",
                                  "enName": "{{metricsInfo.realtime_new.en}}",
                                  "cnName": "{{metricsInfo.realtime_new.cn}}",
                                },
                                {
                                  "value": "2",
                                  "enName": "{{metricsInfo.realtime_active.en}}",
                                  "cnName": "{{metricsInfo.realtime_active.cn}}",
                                },
                                {
                                  "value": "3",
                                  "enName": "{{metricsInfo.realtime_retention_d2.en}}",
                                  "cnName": "{{metricsInfo.realtime_retention_d2.cn}}",
                                },
                                {
                                  "value": "4",
                                  "enName": "{{metricsInfo.realtime_retention_d3.en}}",
                                  "cnName": "{{metricsInfo.realtime_retention_d3.cn}}",
                                },
                                {
                                  "value": "5",
                                  "enName": "{{metricsInfo.realtime_retention_d7.en}}",
                                  "cnName": "{{metricsInfo.realtime_retention_d7.cn}}",
                                }
                              ],
                              "scrollMarginTop": "75px"
                            }
                          },
                          "children": [
                            {
                              "name": "MetricComponent",
                              "path": "realtime/users",
                              "componentKey": "NewUsersByDimensionCard",
                              "id": 1,
                              "config": {}
                            },
                            {
                              "name": "MetricComponent",
                              "path": "realtime/users",
                              "componentKey": "ActiveUsersByDimensionCard",
                              "id": 2,
                              "config": {}
                            },
                            {
                              "name": "MetricComponent",
                              "path": "realtime/users",
                              "componentKey": "RetentionD2ByDimensionCard",
                              "id": 3,
                              "config": {}
                            },
                            {
                              "name": "MetricComponent",
                              "path": "realtime/users",
                              "componentKey": "RetentionD3ByDimensionCard",
                              "id": 4,
                              "config": {}
                            },
                            {
                              "name": "MetricComponent",
                              "path": "realtime/users",
                              "componentKey": "RetentionD7ByDimensionCard",
                              "id": 5,
                              "config": {}
                            },
                          ]
                        }
                      ]
                    }
                  ]
                }
              ]
            }
          ]
        }
      ]
    },
    {
      "id": "changeAnalysis",
      "tabName": "Change Analysis",
      "tabNameCN": "异动分析",
      "isHaveNotification": true,
      "refresh": true,
      "notificationPath": "/realtime/users/changeAnalysis",
      "path": "/realtime/users/changeAnalysis",
      "tabIcon": "",
      "logConfig": {
        "pageId": "200503",
        "pageName": "realtimeRealtimeUsersChangeAnalysis",
        "extInfo": "realtimeRealtimeUsersChangeAnalysis",
        "pagePath": "/realtime/users/changeAnalysis"
      },
      "filters": [
        {
          "data": {
            "activeTab": "common"
          },
          "name": "realtimeAnalysisFilter",
          "isOpenSticky": false,
          "isHaveFilterSave": true,
          "filterPath": "/realtime/users/changeAnalysis",
          "selectorApi": "/api/v1/dashboard/pc/realtime/ua/selector",
          "extraSelectorParams": {
            "data_source": "dashboard"
          },
          "componentList": [
            {
              "name": "MetricInfo",
              "children": [
                {
                  "name": "realtimeUserService",
                  "className": "",
                  "type": "view",
                  "style": {},
                  "props": {
                    "config": {
                      "api": "/api/v1/dashboard/realtime/change/new_active_online",
                      "dataKey": "analysis_online",
                      "refreshKey": "realtime_analysis_online",
                      "interval": 300000,
                      "extraParams": {
                        "metrics": ["active_users", "new_users"],
                      },
                    }
                  },
                  "data": {
                    "is_key_country": false,
                    "trend_type": "all",
                    "hour": "23:59"
                  },
                  "children": [
                    {
                      "name": "realtimeUserService",
                      "className": "",
                      "type": "view",
                      "style": {},
                      "props": {
                        "config": {
                          "api": "/api/v1/dashboard/realtime/change/retention/d237",
                          "dataKey": "analysis_d237",
                          "refreshKey": "realtime_analysis_d237",
                          "interval": 300000
                        }
                      },
                      "children": [
                        {
                          "name": "ChangeAnalysisContext",
                          "className": "margin-t-20",
                          "style": {},
                          "type": "view",
                          "props": {
                            "config": {
                              "componentSegment": [
                                {
                                  "value": "1",
                                  "enName": "Total",
                                  "cnName": "汇总",
                                  "disable": false,
                                  "rainbowKey": "",
                                  "enTooltip": "",
                                  "cntooltip": "",
                                  "is_key_country": false
                                },
                                {
                                  "value": "2",
                                  "enName": "Key Country/Market",
                                  "cnName": "关注国家",
                                  "rainbowKey": "",
                                  "disable": false,
                                  "enTooltip": "",
                                  "cntooltip": "",
                                  "is_key_country": true
                                }
                              ]
                            }
                          },
                          "children": [
                            {
                              "name": "MetricComponent",
                              "path": "realtime/users",
                              "componentKey": "NewUsersChangeAnalysisCard",
                              "config": {}
                            },
                            {
                              "name": "MetricComponent",
                              "path": "realtime/users",
                              "componentKey": "ActiveUsersChangeAnalysisCard",
                              "config": {}
                            },
                            {
                              "name": "MetricComponent",
                              "path": "realtime/users",
                              "componentKey": "RetentionD2ChangeAnalysisCard",
                              "config": {}
                            },
                            {
                              "name": "MetricComponent",
                              "path": "realtime/users",
                              "componentKey": "RetentionD3ChangeAnalysisCard",
                              "config": {}
                            },
                            {
                              "name": "MetricComponent",
                              "path": "realtime/users",
                              "componentKey": "RetentionD7ChangeAnalysisCard",
                              "config": {}
                            },
                          ]
                        }
                      ]
                    }
                  ]
                }
              ],
            },
          ]
        }
      ]
    },
    {
      "id": "dataDownload",
      "tabName": "Data Download",
      "tabNameCN": "数据下载",
      "isHaveNotification": true,
      "notificationPath": "/realtime/users/dataDownload",
      "path": "/realtime/users/dataDownload",
      "tabIcon": "",
      "logConfig": {
        "pageId": "200504",
        "pageName": "realtimeRealtimeUsersDataDownload",
        "extInfo": "realtimeRealtimeUsersDataDownload",
        "pagePath": "/realtime/users/dataDownload"
      },
      "filters": [
        {
          "name": "realtimeDownloadFilter",
          "isOpenSticky": false,
          "isHaveFilterSave": true,
          "filterPath": "/realtime/users/dataDownload",
          "selectorApi": "/api/v1/dashboard/pc/realtime/ua/selector",
          "extraSelectorParams": {
            "data_source": "dashboard"
          },
          "componentList": [
            {
              "name": "MetricInfo",
              "children": [
                {
                  "name": "MetricComponent",
                  "path": "realtime/users",
                  "componentName": "DataDownloadTableCo",
                  "componentKey": "RealtimeDataDownloadTable",
                  "data": {
                    "tableMetric": ["acc_new_users", "acc_active_users"],
                  },
                  "config": {
                    "props": {
                      "config": {
                        "titleEn": "Users Data Overall Performance",
                        "titleCn": "用户数据总体表现",
                        "api": {
                          "tableApi": "/api/v1/dashboard/realtime/overall/userinfo",
                          "tableDownloadApi": "/api/v1/dashboard/realtime/overall/userinfo/download"
                        },
                      },
                    }
                  },
                },
                {
                  "name": "MetricComponent",
                  "path": "realtime/users",
                  "componentName": "DataDownloadTableCo",
                  "componentKey": "RealtimeDataDownloadTable",
                  "data": {
                    "tableMetric": ["d2", "d3", "d7"],
                  },
                  "config": {
                    "props": {
                      "config": {
                        "titleEn": "Retention Overall Performance",
                        "titleCn": "留存整体表现",
                        "api": {
                          "tableApi": "/api/v1/dashboard/realtime/overall/d237",
                          "tableDownloadApi": "/api/v1/dashboard/realtime/overall/d237/download"
                        },
                      },
                    }
                  },
                },
              ]
            },
          ]
        }
      ]
    }
  ]
};